import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { authGuard } from './guard/auth.guard';
import { notUnderMaintenanceGuard } from './guard/maintenance.guard';
import { PlaceholderComponent } from './pages/ui-components/placeholder/placeholder.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'garage/admin' },

  // Declared before the console shell: the shell is mounted at '' and would otherwise
  // be matched first, leaving the authentication pages reachable only by router
  // backtracking, and running the auth guard on the very pages used to sign in.
  {
    path: 'pages',
    component: BlankComponent,
    loadChildren: () =>
      import('./pages/authentication/authentication.routes').then((m) => m.AuthenticationRoutes),
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [notUnderMaintenanceGuard, authGuard],
    loadChildren: () => import('./pages/apps/apps.routes').then((m) => m.AppsRoutes),
  },
  // The previous app had no wildcard, so a mistyped or stale URL rendered an empty
  // shell with no indication that anything had gone wrong.
  {
    path: '**',
    component: BlankComponent,
    children: [
      {
        path: '',
        component: PlaceholderComponent,
        title: 'Pagina non trovata',
        data: {
          title: 'Pagina non trovata',
          description: "L'indirizzo richiesto non esiste.",
          icon: 'error_outline',
        },
      },
    ],
  },
];
